export default "__VITE_ASSET__oYvCErED__"